import styled from "styled-components";

import {
  a,
  detailsBig,
  detailsSmall,
  h3,
  paragraph,
} from "@/styles/typography";

const P = styled.p`
    z-index: 1;
    padding: 1rem;
    color: white;
    position: absolute;
    top: 0;
    font-family: Avenir next;
    text-transform: capitalize;
    font-size: 0.5rem;
    opacity: 0.5;
`;

const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 53% 45%;
  grid-template-rows: repeat(2, 1fr);
  gap: 20px;

  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: 100%;
    grid-template-rows: 1fr 1fr;
  }
`;

const GridItem = styled.div`
  &:first-of-type {
    grid-row: 1 / span 2;
    min-height: 750px;
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    &:first-of-type {
      grid-row: 1 / span 2;
      min-height: 360px;
      max-height: 365px;
    }
  }
`;

const Card = styled.div`
  height: 100%;
  min-height: 100%;
  max-height: 750px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;

  .gatsby-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    width: 100%;
    max-width: 100vw;
    height: 365px;
  }
`;

const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const Category = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  position: absolute;
  top: 0;
  z-index: 2;
`;

const TextWrapper = styled.div`
  background-color: transparent;
  padding: 20px;
  height: 75%;
  max-height: 400px;
  z-index: 2;
  overflow: hidden;
`;

const Date = styled(detailsSmall)`
  color: ${({ theme }) => theme.textColors.secondary};
  margin: 10px 0;
  text-transform: uppercase;

  @media ${({ theme }) => theme.breakpoints.md} {
    margin: 0 0 10px 0;
  }
`;

const Title = styled(h3)`
  color: ${({ theme }) => theme.textColors.secondary};
  text-transform: uppercase;
  @media ${({ theme }) => theme.breakpoints.lg} {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

const Line = styled.div`
  border-bottom: 2px solid ${({ theme }) => theme.textColors.secondary};
  width: 200px;
  height: 0px;
  margin: 10px 0 18px 0;
`;

const PWrapper = styled.div`
  max-height: 135px;
  margin-bottom: 30px;
  max-width: 510px;
`;

const Paragraph = styled(paragraph)<{index: number}>`
  color: ${({ theme }) => theme.textColors.secondary};
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: ${({ index }) => (index === 0) ? 7 : 3};
  -webkit-box-orient: vertical;
  @media ${({ theme }) => theme.breakpoints.md} {
    -webkit-line-clamp: 3;
  }
`;

const DetailsBig = styled(detailsBig)`
  color: ${({ theme }) => theme.colors.primary};
  padding: 15px 30px 10px 30px;
  margin: 20px 20px 0 0;
  background-color: #fff;
  transition: all 0.3s ease-out;

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: 16px 16px 0 0;
    padding: 8px 24px;
    font-size: 14px;
    line-height: normal;
  }
`;

const ArrowWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  right: 35px;

  @media ${({ theme }) => theme.breakpoints.sm} {
    bottom: 0px;
    right: 23px;
  }
`;

const HoverWrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.65);
  height: 75%;
  max-height: 400px;
  width: 100%;
  transition: all 0.3s ease-out;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
`;

const LinkWrapper = styled(a)`
  text-decoration: none;

  @media ${({ theme }) => theme.breakpoints.hover} {
    &:hover {
      ${HoverWrapper} {
        height: 100%;
        max-height: 100%;
      }
      ${DetailsBig} {
        background-color: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.textColors.secondary};
      }
    }
  }
`;

const S = {
  Container,
  GridItem,
  Card,
  Image,
  Category,
  TextWrapper,
  Date,
  Title,
  Line,
  PWrapper,
  Paragraph,
  DetailsBig,
  ArrowWrapper,
  HoverWrapper,
  LinkWrapper,
  P
};

export default S;
